import axios from 'axios';

const toReason = (value: unknown) => (typeof value === 'string' ? value.trim() : '');

const isClientErrorStatus = (status?: number) => status !== undefined && status >= 400 && status < 500;

const getApiErrorReason = (error: unknown): string | undefined => {
  if (!error || !axios.isAxiosError(error) || !isClientErrorStatus(error.response?.status)) return undefined;

  const data: unknown = error.response?.data;
  if (!data || typeof data !== 'object') return undefined;

  const { reason, errors_list: errorsList } = data as Record<string, unknown>;
  const listReasons = Array.isArray(errorsList) ? errorsList.map(item => item?.reason) : [];

  return [...listReasons, reason].map(toReason).find(Boolean);
};

export { getApiErrorReason };
